import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-d-flex p-justify-between" }
const _hoisted_2 = { class: "p-input-icon-right" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" }, null, -1)

import CreateFunction from "./CreateFunction.vue";
import UpdateFunction from "./UpdateFunction.vue";
import { useRemoveFunction } from "./hooks/useRemoveFunction";
import { useFunctions } from "./hooks/useFunctions";


export default /*#__PURE__*/_defineComponent({
  __name: 'Functions',
  setup(__props) {

const { loading, functions, filter } = useFunctions();
const { removeLoading, handleRemove } = useRemoveFunction();

return (_ctx: any,_cache: any) => {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Column = _resolveComponent("Column")!
  const _component_Button = _resolveComponent("Button")!
  const _component_DataTable = _resolveComponent("DataTable")!

  return (_openBlock(), _createBlock(UpdateFunction, null, {
    default: _withCtx(({ openUpdate }) => [
      _createVNode(_component_DataTable, {
        value: _unref(functions),
        responsiveLayout: "scroll",
        loading: _unref(loading),
        filters: _unref(filter),
        globalFilterFields: ['name']
      }, {
        header: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(CreateFunction),
            _createElementVNode("span", _hoisted_2, [
              _hoisted_3,
              _createVNode(_component_InputText, {
                placeholder: _ctx.$t('search'),
                modelValue: _unref(filter)['global'].value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(filter)['global'].value) = $event))
              }, null, 8, ["placeholder", "modelValue"])
            ])
          ])
        ]),
        default: _withCtx(() => [
          _createVNode(_component_Column, {
            field: "createdAt",
            header: _ctx.$t('date')
          }, {
            body: _withCtx(({ data, field }) => [
              _createTextVNode(_toDisplayString(_ctx.$d(data[field], "short")), 1)
            ]),
            _: 1
          }, 8, ["header"]),
          _createVNode(_component_Column, {
            field: "name",
            header: "Nom"
          }),
          _createVNode(_component_Column, {
            field: "id",
            header: "Action"
          }, {
            body: _withCtx(({ data, field }) => [
              _createVNode(_component_Button, {
                icon: "pi pi-pencil",
                onClick: ($event: any) => (openUpdate(data))
              }, null, 8, ["onClick"]),
              _createVNode(_component_Button, {
                icon: "pi pi-trash",
                disabled: _unref(removeLoading),
                onClick: ($event: any) => (_unref(handleRemove)($event, data[field])),
                class: "p-button-danger p-ml-2"
              }, null, 8, ["disabled", "onClick"])
            ]),
            _: 2
          }, 1024)
        ]),
        _: 2
      }, 1032, ["value", "loading", "filters"])
    ]),
    _: 1
  }))
}
}

})